/**
 * @name getRandomId
 *
 * @description Returns a random id i.e. "g25s4zkh8"
 *
 * @example
 * import { getRandomId } from '@workbench/core';
 *
 * getRandomId(); // 'g25s4zkh8'
 */
export const getRandomId = (): string => Math.random().toString(36).substr(2, 9);
